import React, { useContext } from 'react';
import { WindowSizeContext } from "../../../../common/context/WindowSizeContext";
import { topLineDisplayNumber, displayNumber, decimalDisplayNumber, abbreviateNumber } from "../../../../common/utils";
import { Box } from '@mui/material';


export default function NumericValueDisplay({ value, prefix, postfix, isAbbreviated, undefinedDisplay = '-', isTopLine, isOnScoreCard, isThousandsOnly, fractionDigits}) {
    const windowSize = useContext(WindowSizeContext);
    
    if (value === 'N/A') {
        if (isOnScoreCard) {
            return value;
        }
        return <Box textAlign={'center'}>
            {value}
        </Box>;
    }

    if ((!value && value !== 0) || !isFinite(value) || isNaN(value)) {
        if (isOnScoreCard) {
            return undefinedDisplay;
        }
        return <Box textAlign={'center'}>
            {undefinedDisplay}
        </Box>;
    }

    const parsedValue = typeof value === 'string' ?
        parseFloat(value) : value;

    let display;

    // Added condition for negative values including -0
    if (parsedValue === 0) {
        display = 0;
    } else if (parsedValue < 1 && Math.sign(parsedValue) !== -1) {
        display = decimalDisplayNumber(parsedValue); // Format value to 3 decimal places if less than 1
    } else if (parsedValue.toString().includes('-0.000')) {
        display = 0; // Replace negative zero with zero
    } else if (fractionDigits !== undefined && fractionDigits !== null) { 
        const isBillions = parsedValue >= 1000000000;
        const isMillions = parsedValue >= 1000000;
        const isThousands = parsedValue >= 1000;
    
        display = abbreviateNumber(parsedValue, isBillions, isMillions, isThousands, fractionDigits, {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        });
    } else {
        const shouldAbbreviate = isTopLine || isAbbreviated;

        const numberDisplay = displayNumber(parsedValue,windowSize.isOnMobile, isThousandsOnly);
        const numberDisplayTop = topLineDisplayNumber(parsedValue,windowSize.isOnMobile && !shouldAbbreviate, isThousandsOnly);

        display = shouldAbbreviate ? numberDisplayTop : numberDisplay;
    }
    return <>{prefix}{display}{postfix}</>;
}
